<template>
  <div>
    <h2>Kho Tuấn</h2>
    <div>
      <b-button
        @click="form_data = {}; action = 'Tạo'"
        v-b-modal.modal-khotuan-form
        variant="primary"
        >Thêm Mới</b-button
      >
      &nbsp;
      <b-button @click="export_excel" variant="primary">Export Excel</b-button> &nbsp;
      <hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px" />
      <table>
        <tr>
          <th>Từ Ngày</th>
          <th>Đến ngày</th>
          <th></th>
        </tr>
        <tr>
          <td><input id="date-filter-start" /></td>
          <td><input id="date-filter-end" /></td>
          <td></td>
        </tr>
      </table>
      <br>
      <b-modal
        id="modal-khotuan-form"
        no-close-on-backdrop
        hide-header-close
        title="Thêm Kho Tuấn Item"
      >
        <khotuan-form
          @refresh_table_data="refresh_table_data"
          :form_data="form_data"
          :action="action"
        />
        <template #modal-footer>
          <br />
        </template>
      </b-modal>
    </div>

    <div id="mismatch-filter-wrapper" style="display: none;">
      <label style="margin-right: 15px; cursor: pointer; font-weight: bold; color: #d9534f; display: flex; align-items: center;">
        <input type="checkbox" v-model="onlyShowMismatch" @change="toggleMismatchFilter" style="margin-right: 5px;"> 
        Chỉ hiển thị những mã không khớp      </label>
    </div>

    <table
      class="table table-hover table-bordered cell-border stripe"
      id="khotuan_inventory_table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>Pn 10</th>
          <th>Stamping</th>
          <th>English name</th>
          <th>Import Name<br />(Tên nhập khẩu)</th>
          <th>Nhập Kho</th>
          <th>Xuất kho</th>
          <th>Tồn Kho hiện tại</th>
          <th>Tồn kho kho TLT</th>
          <th>Tổng 2 kho</th>
          <th>Tồn cuối kho chính</th>
          <th>Vị trí</th>
          <th>Giá nhập (DAP)</th>
          <th>Tổng Giá</th>
          <th>Ghi Chú</th>
          <th></th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th>Pn 10</th>
          <th>Stamping</th>
          <th>English name</th>
          <th>Import Name</th>
          <th>Nhập Kho</th>
          <th>Xuất kho</th>
          <th>Tồn Kho hiện tại</th>
          <th>Tồn kho kho TLT</th>
          <th>Tổng 2 kho</th>
          <th>Tồn cuối kho chính</th>
          <th>Vị trí</th>
          <th>Giá nhập (DAP)</th>
          <th>Tổng Giá</th>
          <th>Ghi Chú</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import tool_mixin from "./tool_mixins.js";
import moment from "moment";
import "daterangepicker/daterangepicker";
import "daterangepicker/daterangepicker.css";
import XLSX from 'xlsx';
import KhoTuanForm from "./KhoTuanForm.vue";

export default {
  mixins: [tool_mixin],
  data: function () {
    return {
      table: null,
      export_file_name: "khotuan_Inventory_" + moment().format("DD_MM_YYYY"),
      form_data: {},
      action: "Tạo",
      khoTLTMap: {}, // Map tra cứu tồn kho TLT nhanh
      onlyShowMismatch: false, // Checkbox trạng thái
      columns: [
        { data: "pn_10", defaultContent: "" },
        { data: "stamping", defaultContent: "" },
        { data: "english_des", defaultContent: "" },
        { data: "import_des", defaultContent: "" },
        { data: "so_luong_nhap", defaultContent: "0" },
        { data: "so_luong_xuat", defaultContent: "0" },
        { data: "ton_kho_hien_tai", defaultContent: "0" },
        { 
          data: "pn_10", 
          title: "Tồn kho kho TLT",
          render: (data) => this.khoTLTMap[data ? data.trim() : ""] || 0 
        },
        { 
          data: "pn_10",
          title: "Tổng 2 kho",
          render: (data, type, row) => {
            const ton_tlt = this.khoTLTMap[data ? data.trim() : ""] || 0;
            const ton_tuan = Number(row.ton_kho_hien_tai) || 0;
            const tong = ton_tuan + ton_tlt;
            const ton_chinh = Number(row.ton_cuoi_kho_chinh) || 0;
            const errorClass = tong !== ton_chinh ? 'highlight-error' : '';
            return `<span class="${errorClass}">${tong}</span>`;
          }
        },
        { 
          data: "ton_cuoi_kho_chinh",
          render: (data, type, row) => {
            const ton_tlt = this.khoTLTMap[row.pn_10 ? row.pn_10.trim() : ""] || 0;
            const tong = (Number(row.ton_kho_hien_tai) || 0) + ton_tlt;
            const errorClass = tong !== Number(data) ? 'highlight-error' : '';
            return `<span class="${errorClass}">${data || 0}</span>`;
          }
        },
        { data: "location", defaultContent: "" }, // Fix position -> location
        {
          data: "dap_price",
          title: "Giá nhập (DAP)",
          render: $.fn.dataTable.render.number(",", ".", 2),
          defaultContent: "0"
        },
        {
          data: "tong_gia_ton_kho",
          title: "Tổng Giá",
          render: $.fn.dataTable.render.number(",", ".", 2),
          defaultContent: "0"
        },
        { 
          data: "remark", 
          title: "Ghi Chú",
          className: "ellipsis-col",
          defaultContent: ""
        },
        {
          data: null,
          width: 100,
          orderable: false,
          defaultContent:
            '<button type="button" action="edit" class="btn btn-warning flat">Sửa</button>\
             <button type="button" action="delete" class="btn btn-danger flat">Xóa</button>',
        },
      ],
      table_data_url: process.env.VUE_APP_API_ENDPOINT + "/api/v1/warehouses?name=kho_tuan",
      date_filter_start: null,
      date_filter_end: null,
    };
  },
  components: {
    "khotuan-form": KhoTuanForm,
  },
  methods: {
    async fetchKhoTLTBulk() {
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/v1/warehouses`, { 
          params: { name: 'kho_tlt' } 
        });
        const map = {};
        res.data.forEach(item => { if (item.pn_10) map[item.pn_10.trim()] = Number(item.ton_kho_hien_tai) || 0; });
        this.khoTLTMap = map;
      } catch (e) { console.error("Lỗi Bulk Fetch Kho TLT:", e); }
    },
    async refresh_table_data() {
      await this.fetchKhoTLTBulk();
      this.table.ajax.reload();
    },
    toggleMismatchFilter() {
      this.table.draw();
    },
    import_excel(){
      document.getElementById("fileUpload").click()
    },
    upload_excel_file(e){
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      let file = files[0];
      let reader = new FileReader();
      reader.onload = (e) => { this.send_file(e.target.result) };
      reader.readAsBinaryString(file);
    },
    send_file(file){
      let url = process.env.VUE_APP_API_ENDPOINT + "/api/v1/khotuan-inventory/import-excel";
      const wb = XLSX.read(file, { type: 'binary' });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      axios.post(url, {data: data}).then(() => { this.refresh_table_data(); });
    },
    delete_khotuan_item(id) {
      let url = process.env.VUE_APP_API_ENDPOINT + "/api/v1/warehouses/" + id;
      axios.delete(url).then(() => {
        this.$root.$bvModal.msgBoxOk(`Đã Xóa`);
        this.refresh_table_data();
      });
    },
  },
  async mounted() {
    await this.fetchKhoTLTBulk();

    const self = this;
    // Cấu hình lọc Custom
    $.fn.dataTable.ext.search = []; 
    $.fn.dataTable.ext.search.push(function(settings, data, dataIndex) {
      if (!self.onlyShowMismatch) return true;
      const rowData = self.table.row(dataIndex).data();
      if (!rowData) return true;
      const ton_tlt = self.khoTLTMap[rowData.pn_10 ? rowData.pn_10.trim() : ""] || 0;
      const tong = (Number(rowData.ton_kho_hien_tai) || 0) + ton_tlt;
      return tong !== Number(rowData.ton_cuoi_kho_chinh);
    });

    let url = this.table_data_url;
    this.generate_search_boxes();
    
    this.table = $("#khotuan_inventory_table").DataTable({
      pageLength: 50,
      ajax: { url: url, dataSrc: "" },
      columnDefs: [
        { defaultContent: "-", targets: "_all" },
        { width: "200px", targets: 13 }
      ],
      columns: this.columns,
      scrollX: true,
      dom: '<"top-wrapper"lf>rtip',
      initComplete: function () {
        // Đẩy Checkbox vào cạnh ô Search
        $(".dataTables_filter").prepend($("#mismatch-filter-wrapper").show());

        this.api().columns().every( function () {
          var that = this;
          $('input', this.footer()).on('keyup change clear', function () {
            if (that.search() !== this.value) {
              that.search(this.value).draw();
            }
          });
        });
      },
      language: { lengthMenu: "Hiển thị _MENU_ dòng" },
    });

    $("#khotuan_inventory_table tfoot th").each(function () {
      var title = $(this).text();
      $(this).html('<input type="text" style="width:100%" placeholder="Tìm ' + title + '" />');
    });

    $("#khotuan_inventory_table tbody").on("click", "button", function () {
      var data = self.table.row($(this).parents("tr")).data();
      if ($(this).attr("action") == "delete") {
        self.delete_khotuan_item(data.id);
        return;
      }
      self.form_data = Object.assign({}, data);
      self.action = "Sửa";
      self.$bvModal.show("modal-khotuan-form");
    });
  },
};
</script>

<style scoped>
table.dataTable thead th { white-space: nowrap; }
#khotuan_inventory_table button { display: inline-block; height: 35px; margin: 2px; }
table.dataTable td { padding: 5px 10px; white-space: nowrap; }

::v-deep .ellipsis-col {
  max-width: 200px;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

::v-deep .highlight-error {
  color: red !important;
  font-weight: bold;
  padding: 2px 4px;
  border: 1px solid red;
  background-color: #fff0f0;
}

::v-deep .dataTables_filter {
  display: flex;
  align-items: center;
}

#mismatch-filter-wrapper {
  margin-right: 15px;
}
</style>